export default "__VITE_ASSET__Ctmfbc4c__"